var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('data-card',{staticClass:"work-module"}),_c('total-sta',{staticClass:"work-module"}),_c('cover-sta',{staticClass:"work-module"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }